import api from '../..'
import { IQuestionLikertModel } from 'models/questionLikert.model'
import { IOpenEndedModel } from 'models/questionOpenEnded.model'
import { Question, QuestionRating } from 'models/question.model'
import { BlockTypes } from 'enum/block-type.enum'

export const editLikertQuestion = (
  data:
    | IQuestionLikertModel<BlockTypes.BlockSurvey | BlockTypes.BlockEvaluation>
    | Question,
  likertId: number
) => {
  return api.patch(`administration/questions/likerts/${likertId}`, data)
}
export const editOpenEndedQuestion = (
  data: IOpenEndedModel,
  openEndedId: number
) => {
  return api.patch(`administration/questions/open_endeds/${openEndedId}`, data)
}

export async function editQuestionsWeight(questions: QuestionRating[]) {
  const template = {
    likert: {
      likertLabelsAttributes: [],
    },
    question: {
      points: 0,
      blockInstanceableType: 'BlockEvaluation',
    },
  }

  await Promise.all(
    questions.map(async ({ id, weight }: any) => {
      if (id)
        return editLikertQuestion(
          {
            ...template,
            question: { ...template.question, points: weight },
          } as any,
          id
        )
    })
  )
}
